// Call the function to fetch the data

// fetchData();
export const NETWORKS_NUMBER = 22;
export const METADATA = {
  title: 'Luganodes | Hassle-Free Staking',
  description: `Luganodes is a AAA rated institutional-grade staking service provider and one of the top leaders in staking volume. Globally, Luganodes’s client base stakes digital assets across ${NETWORKS_NUMBER}+ PoS live networks with 99% uptime. It is one of the top validator on the Polygon network and the super representative on the Tron network.`,
  twitterHandle: '@luganodes',
  siteUrl: 'https://www.luganodes.com',
};
